import handleAddToBox from "../../src/js/components/addToBox";

const download = {
    init() {
        document.querySelectorAll('.download').forEach(section => {
            this.handleSelectedRows(section);

            handleAddToBox.init(section);

            section.querySelectorAll('.download__header__filters__single').forEach(filter => {
                this.handleSelect(filter, section);
            });

            section.querySelector('#download-selected-files').addEventListener('click', () => {
                const documentRows = section.querySelectorAll('input[name="selected_documents"]:checked');

                const attachments = [];

                documentRows.forEach(documentRow => {
                    const all_languages = section.querySelectorAll(`[name^="document-language-${documentRow.value}"]`);
                    all_languages.forEach(attachment => {
                        attachments.push(attachment.value);
                    });
                });

                window.open(`${download_php.documents_endpoint}?selected_documents=${attachments.join(',')}`);
            });

            section.querySelector('#add-to-download-box').addEventListener('click', () => {
                const productLines = section.querySelectorAll('input[name="selected_documents"]:checked');
                const documents = [...productLines].map(productLine => productLine.value);

                handleAddToBox.addToBox(documents, 'boxed_documents');
            });
        });
    },

    handleSelectedRows(section) {
        section.querySelectorAll('.document_row__name').forEach(row => {
            row.addEventListener('click', () => {
                const checkboxes = section.querySelectorAll('.document_row__name--document input:checked');
                const download_section = section.querySelector('.download__download');

                section.querySelectorAll('.download__download__button .count').forEach(count => {
                    count.innerHTML = '(' + checkboxes.length + ')';
                });

                if (checkboxes.length > 0) {
                    download_section.classList.add('active');
                } else {
                    download_section.classList.remove('active');
                }
            });
        });
    },

    handleSelect(element, section) {
        if (!element) {
            return;
        }

        element.addEventListener('click', (e) => {
            e.stopImmediatePropagation();

            if (element.classList.contains('active')) {
                element.classList.remove('active');
                return;
            }

            section.querySelectorAll('.download__header__filters__single').forEach(filter => {
                filter.classList.remove('active');
            });

            section.querySelectorAll('.document_row__language').forEach(language_select => {
                language_select.classList.remove('active');
            });

            element.classList.toggle('active');
        });

        document.addEventListener('click', (event) => {
            if (!element.contains(event.target)) {
                element.classList.remove('active');
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    download.init();
});
